import React, {useEffect, useState} from "react";
import {LogOut} from "../domains/common/components/Head";
import {
  Button, CircularProgress,
  Divider, Grid, IconButton, InputBase, Link, Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, useTheme
} from "@mui/material";
import Box from "@mui/material/Box";
import {exceptionsTitle, subjectTypeReduced} from "../dictionaries";
import {Link1, Title5} from "../domains/common/components/Typography";
import {Notify} from "../domains/common/components/AlertNotify";
import {Add, Close, Search} from "@mui/icons-material";
import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "../fn";
import {loadUserOptions, userOptions} from "../user";
import {getClientsListData} from "../clientsList";
import {ButtonBase} from "../domains/common/components/Button";

export default function ClientsPage() {
  let [list, setList] = useState([]);
  const [findLoad, setFindLoad] = useState(false);
  const [notify, openNotify] = Notify({open: false});

  const theme = useTheme();

  const getListData = async () => {
    const result = await getClientsListData();

    await loadUserOptions()

    if (result.ok) {
      if (result?.data.length) {
        setList(result.data);
      }
    } else {
      openNotify({
        msg: exceptionsTitle[result.message] || result.message || "Не удалось получить список сделок",
        duration: 5000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  };

  const findParticipant = async (val) => {
    setFindLoad(true)
    const result = await new Promise((resolve) => {
      axios.post(`${getBackendURL()}/subject/list/filter/`, {filter: val}, {
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      }).then((response) => {
        resolve(httpResponse(response.data))
      }).catch((error) => {
        resolve(httpResponseError(error));
      });
    })

    if (result.ok) {
      if (result?.data.length) {
        setList(result.data);
      } else {
        setList([])
      }
    }
    setFindLoad(false)
  }

  useEffect(() => {
    getListData();
  }, [])

  return (
    <>
      <Box sx={{backgroundColor: theme.palette.background.default, position: 'sticky', top: 0, zIndex: 1}}>
        <Grid container spacing={0} id="appHead" sx={{height: '60px'}}>
          <Grid item xs={1.5}/>
          <Grid item xs={1} sx={{color: '#fff', lineHeight: '50px'}}>
            <NewClientButton></NewClientButton>
          </Grid>
          <Grid item xs={1} sx={{color: '#fff', paddingTop: '3px', lineHeight: '50px'}}>
            <Link1 sx={{ color: '#8b8b8b', fontSize: '12pt', textDecoration: "none"}} href="/">Сделки</Link1>
          </Grid>
          <Grid item xs={7} sx={{color: '#333', lineHeight: '50px', paddingTop: '6px', alignItems: 'center'}}
                display="flex" justifyContent="flex-end">
            <FindClientInput handleFind={findParticipant} handleCancel={getListData} loading={findLoad}/>
          </Grid>
          <Grid item xs={1.5}>
            <Box sx={{lineHeight: '50px'}} display="flex" justifyContent="flex-end">
              <LogOut/>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={0} id="appHead" sx={{backgroundColor: theme.palette.background.default}}>
        <Grid item xs={1.5}/>
        <Grid item xs={9} sx={{minWidth: '980px'}}>
          {notify}
          <Grid sx={{height: 5}}></Grid>
          {
            (() => {
              if (list?.length) {
                return (
                  <Grid item xs={12} container spacing={0}>
                    <Grid item xs={12}></Grid>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell xs={6}>Тип</TableCell>
                            <TableCell xs={6}>ФИО | Наименование</TableCell>
                            <TableCell xs={6}>Телефон</TableCell>
                            <TableCell xs={6}>E-mail</TableCell>
                            <TableCell xs={6}>СНИЛС</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            list?.map((item) => {
                              const ref = `/subject?id=${item.id}`
                              return (
                                <TableRow
                                  xs={10}
                                  spacing={0}
                                  hover={true}
                                  key={item.id}
                                  onClick={() => window.open(ref, userOptions.openLinkCurrentTab ? "_self" : "_blank")}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <TableCell xs={6} className='listItem'>{subjectTypeReduced[item.type]}</TableCell>
                                  <TableCell xs={6} className='listItem'>{item.lastName} {item.firstName} {item.middleName} {item.name}</TableCell>
                                  <TableCell xs={6} className='listItem'>{item.phone}</TableCell>
                                  <TableCell xs={6} className='listItem'>{item.email}</TableCell>
                                  <TableCell xs={6} className='listItem'>{item.snils}</TableCell>
                                </TableRow>
                              )
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )
              } else {
                return (<Title5 title="Ничего не найдено"/>)
              }
            })()
          }
        </Grid>
        <Grid item xs={1.5}/>
      </Grid>
    </>)
}

export function NewClientButton() {
  return (
    <a href="/subject"><ButtonBase variant="contained" size="medium" color="primary" startIcon={<Add/>}>Создать</ButtonBase></a>
  )
}

export function FindClientInput({handleFind, handleCancel, loading}) {
  const [val, setVal] = useState('');

  const handleInput = (e) => {
    setVal(e.target.value)
  }

  const handleFindClick = () => {
    handleFind(val)
  }

  return (
    <Paper
      component="div"
      sx={{
        p: '1px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
        height: '25px',
        border: '1px solid #dadada'
      }}
      elevation={0}
    >
      <InputBase
        sx={{ml: 1, flex: 1}}
        placeholder="Найти клиента"
        inputProps={{'aria-label': 'Найти клиента'}}
        onChange={handleInput}
        onKeyPress={(event) => {
          if (event.key === 'Enter')
            handleFindClick()
        }}
      />
      <IconButton type="button" sx={{p: '8px'}} aria-label="search" onClick={handleFindClick}>
        {loading ? <CircularProgress size="10px"/> : <Search sx={{color: '#adadad'}}/>}
      </IconButton>
      <Divider sx={{height: 28, m: 0.2}} orientation="vertical"/>
      <IconButton color="primary" sx={{p: '8px'}} aria-label="directions" onClick={handleCancel}>
        <Close sx={{color: '#adadad'}}/>
      </IconButton>
    </Paper>
  );
}